var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"search-projects"}},[_c('input',{attrs:{"type":"text","placeholder":"Rechercher un projet ..."},on:{"input":_vm.searchProjects}})])
}
var staticRenderFns = []

export { render, staticRenderFns }